import { Injectable } from '@angular/core';

import { ClienteConcorrente } from '../cliente-concorrente';

@Injectable({
    providedIn: 'root'
})
export class ClienteConcorrenteSequenciaService {

    /** Ordena os concorrentes pela sequência */
    sort(entities: ClienteConcorrente[]): ClienteConcorrente[] {
        if (!entities) {
            return [];
        }
        return entities.sort((concorrenteA, concorrenteB) => concorrenteA.sequencia - concorrenteB.sequencia);
    }

    /** Obtem a próxima sequência para os concorrentes */
    getProximaSequencia(entities: ClienteConcorrente[]): number {
        if (!entities || entities.length === 0) {
            return 1;
        }

        // Ordenando pela sequência
        const entitiesSorted = this.sort(entities);
        const ultimaSequencia = entitiesSorted[entitiesSorted.length - 1].sequencia;
        return ultimaSequencia + 1;
    }

    /** Move um concorrente para "cima" (Diminui em -1 a sua sequência) */
    moverParaCima(index: number, entities: ClienteConcorrente[]) {
        if (!entities || entities.length < 2) {
            return;
        }
        if (index <= 0) {
            return;
        }

        const entity = entities[index];
        const seq = entity.sequencia;
        const priorEntity = entities[index - 1];

        entity.sequencia = priorEntity.sequencia;
        priorEntity.sequencia = seq;

        entities = this.sort(entities);
    }

    /** Move um concorrente para "baixo" (Aumenta em +1 a sua sequência) */
    moverParaBaixo(index: number, entities: ClienteConcorrente[]) {
        if (!entities || entities.length < 2) {
            return;
        }
        if (index >= (entities.length - 1)) {
            return;
        }

        const entity = entities[index];
        const seq = entity.sequencia;
        const nextEntity = entities[index + 1];

        entity.sequencia = nextEntity.sequencia;
        nextEntity.sequencia = seq;

        entities = this.sort(entities);
    }

    /** Atualiza a sequência dos concorrente */
    atualizar(entities: ClienteConcorrente[]) {
        entities = this.sort(entities);
        let seq = 1;
        entities.forEach(entity => {
            entity.sequencia = seq;
            seq++;
        });
    }
}
